import { takeEvery, put, call } from "redux-saga/effects";
import {
  FETCH_TASK,
  FETCH_PROJECT_MODULE,
  FETCH_PROJECT_MODULE_CLEAR,
  CHANGE_TASK_STATUS,
  CHANGE_TASK_STATUS_SUCCESS,
  CHANGE_TASK_STATUS_FAILURE,
  SAVE_TASK,
  GENERATE_TASK_ID,
} from "./actionTypes";
import * as types from './actionTypes';
import {
  fetchTask,
  fetchTaskSuccess,
  fetchTaskFailure,
  fetchProjectModule,
  fetchProjectModuleSuccess,
  fetchProjectModuleFailure,
  fetchProjectModuleClear,
  changeTaskStatus,
  changeTaskStatusSuccess,
  changeTaskStatusFailure,
  saveTaskSuccess,
  saveTaskFailure,
  generateTaskIdSuccess,
  generateTaskIdFailure,
} from "./actions";
import { get, post, update, del } from "../../../../helpers/api_helper";
import Swal from "sweetalert2";

// Fetch Task
function* fetchTaskSaga(action) {
  try {
    // const formData = new FormData();
    // formData.append("unit_id", unitId);
    // formData.append("created_by", created_by);
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_FETCH_TASK, action.payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve module!");
    }
    yield put(fetchTaskSuccess(response)); 
  } catch (error) {
    console.error("Saga API Error:", error); 
    yield put(fetchTaskFailure(error.message));
  }
}

function* fetchProjectModuleSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_FETCH_MODULE_DROPDOWN, action.payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve client service dropdown data!");
    }
    yield put(fetchProjectModuleSuccess(response)); 
  } catch (error) {
    console.error("Saga API Error:", error); 
    yield put(fetchProjectModuleFailure(error.message));
  }
}

function* fetchProjectModuleClearSaga(action) {
  fetchProjectModuleClear();
}

function* changeTaskStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_CHANGE_TASK_STATUS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to update head status!');
    }

    yield put({ type: types.CHANGE_TASK_STATUS_SUCCESS, payload: response });

    Swal.fire('Success', response?.message, 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while changing status!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.CHANGE_TASK_STATUS_FAILURE, payload: error });
  }
}

// Create Task Saga
function* saveTaskSaga({ payload }) {
  try {
    const { formData, isEdit } = payload;
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_SAVE_TASK, formData);

    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.message || "Task saved successfully!",
      });
      yield put(saveTaskSuccess(response));
      const unitId = formData.get("unit_id"); 
      if (unitId) {
        yield put(fetchTask(unitId));
      } else {
        console.log("unit_id is missing in formData, fetch not triggered");
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Something went wrong!",
      });
      yield put(saveTaskFailure("Unexpected response format"));
    }
  } catch (error) {
    console.error("Saga API Error:", error);
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while saving the deduction",
    });
    yield put(saveTaskFailure(error.message));
  }
}

// Generate Task ID Saga
function* generateTaskIdSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_GENERATE_TASK_ID, action.payload);
    if (!response || response.status !== "Success") {
      throw new Error(response?.message || "Failed to generate task ID!");
    }
    yield put(generateTaskIdSuccess(response.data));
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put(generateTaskIdFailure(error.message));
  }
}

// Watcher Saga
function* timesheetSetupTaskSaga() {
  yield takeEvery(FETCH_TASK, fetchTaskSaga);  
  yield takeEvery(FETCH_PROJECT_MODULE, fetchProjectModuleSaga); 
  yield takeEvery(FETCH_PROJECT_MODULE_CLEAR, fetchProjectModuleClearSaga);
  yield takeEvery(CHANGE_TASK_STATUS, changeTaskStatusSaga);
  yield takeEvery(SAVE_TASK, saveTaskSaga);
  yield takeEvery(GENERATE_TASK_ID, generateTaskIdSaga);
}

export default timesheetSetupTaskSaga;
